<template>
  <v-row>
    <v-col cols="12" class="dot-leader px-10">
      <b>{{ itemTitle }}</b>
      <div class="dot-leader__dots"></div>
      <label>
        <slot name="content"></slot>
      </label>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: [
    'itemTitle'
  ]
}
</script>
